import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() currentPage: number = 1;
  @Input() lastPage: number = 1;
  @Input() perPage: number = 25;
  @Input() totalItems: number = 0;

  @Output() pageChange = new EventEmitter<number>();
  @Output() perPageChange = new EventEmitter<number>();

  paginationPages: number[] = [];
  perPageOptions = [10, 25, 50, 100];

  ngOnChanges() {
    this.paginationPages = this.getPaginationPages(); // ✅ cache once
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= this.lastPage && page !== this.currentPage) {
      this.pageChange.emit(page);
    }
  }

  onPerPageChange(event: Event) {
    const value = +(event.target as HTMLSelectElement).value;
    this.perPageChange.emit(value);
  }

  getPaginationPages(): number[] {
    const total = this.lastPage;
    const current = Number(this.currentPage);

    const pages = new Set<number>();

    // Always show first 2
    pages.add(1);
    pages.add(2);

    // Active and 2 before/after
    for (let i = current - 2; i <= current + 2; i++) {
      if (i > 2 && i < total - 1) {
        pages.add(i);
      }
    }

    // Always show last 2
    pages.add(total - 1);
    pages.add(total);

    // Convert and sort
    const sorted = Array.from(pages).filter(p => p >= 1 && p <= total).sort((a, b) => a - b);

    // Inject ellipses
    const result: number[] = [];
    let last = 0;

    for (let page of sorted) {
      if (page - last > 1) {
        result.push(-1); // represents "..."
      }
      result.push(page);
      last = page;
    }

    return result;
  }

}
